import {CommentModel, CommentStatusesEnum} from '../../../models/api/commentModel';
import {ApiActivityDataGroup, DataGroupModel} from '../../../models/api/dataGroupModel';
import {postApiAsync} from '../../../services/http/http';
import {HttpResponseError} from '../../../services/http/httpError';

export async function sendCommentApiAsync(
  conversationUrl: string,
  comment: CommentModel,
  body: any,
): Promise<DataGroupModel> {
  const url = `${conversationUrl}/timeline`;
  return catchCommentAlreadySentAsync(comment, () => postApiAsync(ApiActivityDataGroup, url, body));
}

export async function catchCommentAlreadySentAsync(
  comment: CommentModel,
  callbackAsync: () => Promise<DataGroupModel>,
): Promise<DataGroupModel> {
  try {
    return await callbackAsync();
  } catch (error) {
    // If the comment is already sent, mark it as such in the client-side state and hope that someday we'll
    // re-fetch the comment and its activity...
    // TODO: Make the API send the activity and comment in the error response.
    if (isCommentAlreadySentResponseError(error)) {
      return {
        comments: [
          {
            ...comment,
            status: CommentStatusesEnum.SENT,
          },
        ],
      };
    }

    throw error;
  }
}

function isCommentAlreadySentResponseError(error: unknown): boolean {
  return (
    error instanceof HttpResponseError &&
    error.status === 400 &&
    error.reason === 'Cannot send a comment that is not a draft.'
  );
}
